import { render, staticRenderFns } from "./approvalActivitiesTwo.vue?vue&type=template&id=54537187&scoped=true&"
import script from "./approvalActivitiesTwo.vue?vue&type=script&lang=js&"
export * from "./approvalActivitiesTwo.vue?vue&type=script&lang=js&"
import style0 from "./approvalActivitiesTwo.vue?vue&type=style&index=0&id=54537187&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54537187",
  null
  
)

export default component.exports